/**
 * Shared constants and value mappings for vehicle lists
 */

/**
 * Status value mapping for vehicle status badges
 */
export const VEHICLE_STATUS_VALUE_MAPPING = [
	{
		value: 'active',
		label: 'Active',
		color: { type: 'success' },
	},
	{
		value: 'inactive',
		label: 'Inactive',
		color: { type: 'neutral' },
	},
	{
		value: 'maintenance',
		label: 'Maintenance',
		color: { type: 'warning' },
	},
	{
		value: 'offline',
		label: 'Offline',
		color: { type: 'danger' },
	},
] as const;
